export const LoginDataAction = {
    UPDATE_LOGIN_DATA: 'UPDATE_LOGIN_DATA',
    UPDATE_LOGIN_DATA_HEADER_STATE: 'UPDATE_LOGIN_DATA_HEADER_STATE',
    SHOWING_ERROR_MESSAGE: 'SHOWING_ERROR_MESSAGE',
    NOT_SHOWING_ERROR_MESSAGE: 'NOT_SHOWING_ERROR_MESSAGE',
    SHOWING_GESTURE_LOGIN_FORM: 'SHOWING_GESTURE_LOGIN_FORM',
    NOT_SHOWING_GESTURE_LOGIN_FORM: 'NOT_SHOWING_GESTURE_LOGIN_FORM',
    SET_LOGIN_CODE_IMAGE: 'SET_LOGIN_CODE_IMAGE',
    NOT_SHOWING_LOGIN_CODE_IMAGE: 'NOT_SHOWING_LOGIN_CODE_IMAGE',
    UPDATE_LOGIN_DATA_WITH_GESTURE: 'UPDATE_LOGIN_DATA_WITH_GESTURE', // TODO: 重新命名
    UPDATE_BACKDOOR_LOGIN_DATA: 'UPDATE_BACKDOOR_LOGIN_DATA',
    SHOWING_MEMBER_RULES: 'SHOWING_MEMBER_RULES',
    NOT_SHOWING_MEMBER_RULES: 'NOT_SHOWING_MEMBER_RULES',
    CLEAR_LOGIN_DATA: 'CLEAR_LOGIN_DATA',
};

export const getInitialLoginDataState = (state) => ({
    username: '',
    password: '',
    platform: state.platform,
    language: state.language,
    loginCode: '',
    enterPoint: state.enterPoint,
    isShowLoginErrorMessage: false,
    errorMessage: {
        errorMessage: [],
        replacedText: '',
        replacedText1: '',
    },
    gestureToggle: false,
    isShowLoginCodeForm: false,
    loginCodeImage: '',
    isShowMemberRules: false,
    redirectUrl: '',
});

export const LoginDataReducer = (state, action) => {
    switch (action.type) {
    case LoginDataAction.UPDATE_LOGIN_DATA:
        return {
            ...state,
            [action.payload.key]: action.payload.value,
        };
    case LoginDataAction.UPDATE_LOGIN_DATA_HEADER_STATE:
        return {
            ...state,
            isGesture: action.payload.isGesture,
            platform: action.payload.platform,
            language: action.payload.language,
            enterPoint: action.payload.enterPoint,
        };
    case LoginDataAction.SHOWING_ERROR_MESSAGE:
        return {
            ...state,
            isShowLoginErrorMessage: true,
            errorMessage: {
                ...state.errorMessage,
                errorMessage: action.payload.errorMessage.errorMessage,
                replacedText: action.payload.errorMessage.replacedText,
                replacedText1: action.payload.errorMessage.replacedText1,
            },
        };
    case LoginDataAction.NOT_SHOWING_ERROR_MESSAGE:
        return {
            ...state,
            isShowLoginErrorMessage: false,
            errorMessage: {
                errorMessage: '',
            },
        };
    case LoginDataAction.SHOWING_GESTURE_LOGIN_FORM:
        return {
            ...state,
            gestureToggle: true,
        };
    case LoginDataAction.NOT_SHOWING_GESTURE_LOGIN_FORM:
        return {
            ...state,
            gestureToggle: false,
        };
    case LoginDataAction.SET_LOGIN_CODE_IMAGE:
        return {
            ...state,
            isShowLoginCodeForm: true,
            loginCodeImage: action.payload.loginCodeImage,
        };
    case LoginDataAction.NOT_SHOWING_LOGIN_CODE_IMAGE:
        return {
            ...state,
            isShowLoginCodeForm: false,
        };
    case LoginDataAction.UPDATE_LOGIN_DATA_WITH_GESTURE:
        return {
            ...state,
            isGesture: true,
            password: action.payload.password,
        };
    case LoginDataAction.UPDATE_BACKDOOR_LOGIN_DATA:
        return {
            ...state,
            platform: action.payload.platform,
            language: action.payload.language,
            alwaysGoToCloud: action.payload.alwaysGoToCloud,
        };
    case LoginDataAction.TOGGLE_SHOWING_MEMBER_RULES:
        return {
            ...state,
            isShowMemberRules: action.payload.isShowMemberRules,
        };
    case LoginDataAction.CLEAR_LOGIN_DATA:
        return getInitialLoginDataState(state);
    default:
        return state;
    }
};
